'use strict';
import actionTypes from './actionTypes';
if (typeof window !== 'undefined') {
    var $ = window.$;
}

function getUnreadCount() {
    return function (dispatch) {
        $.ajax({
            url: '/chat/inbox/getUnreadCount',
            type: 'GET',
            success: function (result) {
                return dispatch({
                    type: actionTypes.GET_UNREAD_COUNT,
                    unreadCount: parseInt(result)
                });
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            }
        });
    };
}

export { getUnreadCount };

export default {
    getUnreadCount: getUnreadCount
};
